var splitter = function($el, type = "lines") {
  // Handle jQuery or vanilla element
  const el = ($el instanceof HTMLElement) ? $el : $el[0]

  let split = new SplitText(el, {
    type: type,
    linesClass: "splittext--line",
    wordsClass: "splittext--word",
    charsClass: "splittext--char",
  })

  if (type.includes('lines')) {
    const lines = el.querySelectorAll('.splittext--line')
    lines.forEach(line => {
      const wrapper = document.createElement('div')
      wrapper.className = 'splittext--linein'
      while (line.firstChild) {
        wrapper.appendChild(line.firstChild)
      }
      line.appendChild(wrapper)
    })
  }

  this.revert = function() {
    split.revert()
  }
}

export default splitter
